import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { mainApi } from 'modules/api';
import { iotaListener } from 'modules/auth';
import { dialogSlice } from 'modules/dialogs';

const rootReducer = combineReducers({
  [mainApi.reducerPath]: mainApi.reducer,
  [dialogSlice.name]: dialogSlice.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      // TODO: fix serializable error
      // https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
      serializableCheck: false,
    })
      .concat(iotaListener.middleware)
      .concat(mainApi.middleware),
});

setupListeners(store.dispatch);

export type Store = typeof store;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
